// import React, { useState } from 'react'
import { useEffect } from 'react';
import Header from '../components/Header';
import Login from '../components/Login';
import { getRedirectUrlFromParam } from '../lib/helpers';

import { Link } from 'react-router-dom';

const AuthorizePage = () => {
  useEffect(() => {
    const url = new URL(window.location.href);

    if (
      !url.searchParams.has('response_type') ||
      !url.searchParams.has('client_id') ||
      !url.searchParams.has('state') ||
      !url.searchParams.has('scope') ||
      !url.searchParams.has('redirect_uri') ||
      !url.searchParams.has('state') ||
      !url.searchParams.has('code_challenge') ||
      !url.searchParams.has('code_challenge_method')
    ) {
      // navigate('/login')
      // TODO this is a hack for now, we need to fix
      window.location.href = 'https://app.bloodygoodtests.com.au';
    }
  });

  const alternateRedirectUrl = getRedirectUrlFromParam();

  return (
    <div className="grid lg:grid-cols-2 lg:gap-6 w-full justify-center">
      <div className="hidden lg:block h-full max-h-screen py-8 sticky top-0">
        <div
          className="h-full w-full rounded-md overflow-hidden bg-cover flex flex-col justify-end bg-center"
          style={{ backgroundImage: 'url(/img/login.jpg)' }}
        ></div>
      </div>

      <div className="max-w-sm flex flex-col items-start justify-center min-h-screen mx-auto py-8">
        <Header
          heading="Login to your account"
          paragraph="Enter your email below to login to your account. "
          hideAuthMode={alternateRedirectUrl ? true : false}
        />

        <Login />

        <p className="text-sm text-gray-500 text-center self-center mt-6">
          Don't have an account yet?{' '}
          <Link className="underline" to={`/signup${window.location.search}`}>
            Signup
          </Link>
        </p>
      </div>
    </div>
  );
};

export default AuthorizePage;
